<template>
  <div>
    <v-dialog
        v-model="model"
        scrollable
        @click:outside="fecharModal"
        :persistent="persistencia"
        :max-width="maxWidth"
        style="padding: 0">
      <v-card class="card-component">
        <v-toolbar dark color="primary" elevation="0">
          <v-toolbar-title>{{ titulo }}</v-toolbar-title>
          <v-spacer/>
          <v-btn class="close__button" text @click="cancelar" icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-5">
          <div
              class="container-upload"
              :class="{ 'dragging': isDragging }"
              @click="abrirSeletorArquivos"
              @dragover.prevent="onDragOver"
              @dragleave="onDragLeave"
              @drop.prevent="onDrop">
            <div class="container-upload-info">
              <v-img
                  v-if="previewFoto"
                  id="arquivoImagemSelecionada"
                  :src="previewFoto"
                  aspect-ratio="4/3"
                  contain
              />
              <v-btn class="btn-upload" depressed>{{ tituloBtn }}</v-btn>
              <label>Arraste e solte os arquivos aqui para serem carregados.</label>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <label v-if="arquivo">{{ arquivo.name }}{{ tamanhoArquivo }}</label>
          <v-spacer/>
          <v-btn @click="enviarArquivo" outlined>Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <input ref="fileInput" @change="selecionarArquivo" type="file" style="display:none" :accept="contentType"/>
  </div>
</template>

<script>
import heic2any from 'heic2any'

export default {
    name: 'FileInputModal',
    props: {
        value: {
            type: Boolean,
            required: true
        },
        titulo: {
            type: String,
            default: 'Envie o arquivo'
        },
        tituloBtn: {
            type: String,
            default: 'Importar Arquivos'
        },
        contentType: {
            type: String,
            default: 'image/png, image/jpeg, application/pdf'
        },
        persistencia: {
            type: Boolean,
            default: true
        },
        maxWidth: {
            type: Number,
            default: 600
        },
    },
    data() {
        return {
            arquivo: null,
            tamanhoArquivo: null,
            nomeArquivo: null,
            isDragging: false,
            previewFoto: null
        }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    methods: {
        fecharModal() {
            if (!this.persistencia) {
                this.cancelar()
            }
        },
        cancelar() {
            if (this.previewFoto) {
                URL.revokeObjectURL(this.previewFoto)
                this.previewFoto = null
            }
            this.model = false
            this.$emit('modalInputFechar')
        },
        abrirSeletorArquivos() {
            this.$refs.fileInput.click()
        },
        async selecionarArquivo(event) {
            const arquivoSelecionado = event.target.files[0]
            if (arquivoSelecionado) {
                this.arquivo = await this.converterFormatoArquivo(arquivoSelecionado)
                this.tamanhoArquivo = ' (' + this.calcularTamanho(this.arquivo.size) + ')'
                if (arquivoSelecionado.type.startsWith('image/')) {
                    this.previewFoto = URL.createObjectURL(arquivoSelecionado)
                }
            }
        },
        onDrop(event) {
            const arquivoSelecionado = event.dataTransfer.files[0]
            if (arquivoSelecionado) {
                this.arquivo = arquivoSelecionado
                this.tamanhoArquivo = ' (' + this.calcularTamanho(arquivoSelecionado.size) + ')'
                if (arquivoSelecionado.type.startsWith('image/')) {
                    this.previewFoto = URL.createObjectURL(arquivoSelecionado)
                }
            }
        },
        onDragOver() {
            this.isDragging = true
        },
        onDragLeave() {
            this.isDragging = false
        },
        calcularTamanho(bytes) {
            if (bytes === 0) return '0 Bytes'
            const k = 1024
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
            const i = Math.floor(Math.log(bytes) / Math.log(k))
            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
        },
        enviarArquivo() {
            if (this.isArquivoValido()) {
                this.model = false
                this.$emit('selecionarArquivo', this.arquivo)
            }
        },
        isArquivoValido() {
            if (!this.arquivo) {
                this.mostrarNotificacaoErro('Anexe o arquivo!')
                return false
            }
            return true
        },
        async converterFormatoArquivo(arquivoSelecionado) {
            if (arquivoSelecionado.name.endsWith('.HEIC')) {
                const blob = await heic2any({
                    blob: arquivoSelecionado,
                    toType: 'image/jpeg',
                    quality: 0.8
                })
                return new File([blob], arquivoSelecionado.name.replace(/\.[^/.]+$/, '.jpg'), {
                    type: 'image/jpeg'
                })
            }

            return arquivoSelecionado
        }
    }
}
</script>

<style scoped lang="stylus">

.container-upload
  height 300px
  display flex
  justify-content center
  align-items center
  background-color #eee
  border 2px dashed #ccc

.container-upload:hover
  cursor pointer
  border-color #aaa

.container-upload.dragging {
  border-color #3b82f6
  background #e0f2fe
}

.container-upload-info
  display flex
  flex-direction column

.btn-upload
  background-color #d28a2c !important
  color white
  text-transform none

#arquivoImagemSelecionada
  height 200px
  width 200px
  border 2px solid #eee
  align-self center

</style>